/**
 * Sysadmin Argus Live catalog — pure layout route (R5 P0-1 defensive fix,
 * 2026-05-13).
 *
 * Before the fix, this file held both the route registration AND the
 * list-page component. TanStack file-based routing auto-nests the
 * child route `catalog.argus-live.$id` under this parent, but without
 * an <Outlet/> in the parent component, the child route had nowhere
 * to render and the list stayed mounted at
 * `/sysadmin/catalog/argus-live/<id>`.
 *
 * The list content moved to `catalog.argus-live.index.tsx` (route ID
 * `/sysadmin/catalog/argus-live/`). This file is now a pure layout,
 * mirroring the canonical sibling pattern at `routes/sysadmin/models.tsx`.
 *
 * Not in the Round-5 audit's reproduction set, but fixed defensively
 * because the same defective pattern was present and the same
 * symptom (`/sysadmin/catalog/argus-live/<id>` mounts the list) would
 * surface as soon as anyone clicked an Argus Live row.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/argus-live')({
  component: ArgusLiveCatalogLayout,
});

function ArgusLiveCatalogLayout() {
  return <Outlet />;
}
